__turbopack_context__.v({
  "noVerticalPadding": "styles-module__FFKniq__noVerticalPadding",
  "tabPanel": "styles-module__FFKniq__tabPanel",
});
